import { render, staticRenderFns } from "./kore-chat.vue?vue&type=template&id=35e4ae9e&scoped=true&"
import script from "./kore-chat.vue?vue&type=script&lang=js&"
export * from "./kore-chat.vue?vue&type=script&lang=js&"
import style0 from "./kore-chat.vue?vue&type=style&index=0&id=35e4ae9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4ae9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSpacer,VSystemBar,VTextField})
